import axios from 'axios';

export const publicAxiosInstance = axios.create({
    baseURL: '/'
});

// No authentication interceptor - this is a public endpoint
